var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['chip', {warning: _vm.warning}]},[_c('p',{staticClass:"display-small-tiny"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"remove-icon",domProps:{"innerHTML":_vm._s(_vm.Icon.CROSS)},on:{"click":function($event){return _vm.$emit('remove')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }